(ns manage.adset-decision-tree-page.tagging-and-trackers.meta-pixel.db
  (:require [re-frame.core :as rf]))

(rf/reg-sub ::meta-pixel
  (fn [db _]
    (::meta-pixel db)))

(rf/reg-event-db ::set-meta-pixel
  (fn [db [_ meta-pixel]]
    (assoc db ::meta-pixel meta-pixel)))
